import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

type Options = {
  preserveParams: boolean;
};

const useQueryParams = (options: Options = { preserveParams: false }) => {
  const { pathname, search } = useLocation();
  const { replace } = useHistory();
  const [queryParams] = useState(() => {
    const searchParams = new URLSearchParams(search);
    return Object.fromEntries(searchParams.entries());
  });

  useEffect(() => {
    if (!options.preserveParams) {
      replace(pathname);
    }
  }, []);

  return queryParams;
};

export default useQueryParams;
